module.exports = __webpack_public_path__ + "img/tu2.10c74694.png";